// @flow

import React from "react";

import { Grid, GridItem, HStack, VStack, Text } from "@chakra-ui/react";

import Icon from "src/icons";
import Select from "src/components/Select";
import StitchData from "./StitchData";

import { backendUrl } from "src/config/firebase";

import * as styles from "./styles";
import type { Stitch as StitchType } from "src/types";

const stitchTypes = {
  api: "PDF Generator API",
  apiV2: "PDF Generator API v2",
  template: "Adobe Generate PDF from Template",
  nativeFile: "Adobe Convert Native File to PDF",
  unifizePdf: "Unifize PDF"
};

type Props = {
  data: StitchType,
  onUpdate: Function
};

const getStitchType = stitch => {
  if (stitch.templateId !== undefined && stitch.useV2 === true) {
    return "apiV2";
  }

  if (stitch.templateId !== undefined) {
    return "api";
  }

  if (stitch.fieldId !== undefined) {
    return "nativeFile";
  }

  if (stitch.unifizePdfId !== undefined && backendUrl.includes("unifize.us")) {
    return "unifizePdf";
  }

  return "template";
};

const valueMap = {
  api: "templateId",
  apiV2: "templateId",
  nativeFile: "fieldId",
  template: "name",
  unifizePdf: "unifizePdfId"
};

export default function Stitch({ data, onUpdate }: Props) {
  const stitchType = getStitchType(data);
  const valueKey = valueMap[stitchType];

  const setStitchType = newType => {
    let newData = {
      seqNo: data.seqNo,
      [valueMap[newType]]: null
    };
    if (newType === "apiV2") {
      newData = { ...newData, useV2: true };
    }
    onUpdate(data.seqNo, newData);
  };

  const updateStitchData = newData => {
    onUpdate(data.seqNo, { ...data, [valueKey]: newData });
  };

  return (
    <Grid {...styles.StitchContainer}>
      <GridItem>
        <VStack {...styles.StitchItem}>
          <HStack>
            <span style={styles.StitchLabel}>TYPE</span>
            <Icon type="info" filled width="13" height="13" />
          </HStack>

          <Select
            value={stitchType}
            label={stitchTypes[stitchType]}
            onChange={setStitchType}
            width="100%"
          >
            {Object.keys(stitchTypes).map(item =>
              item === "unifizePdf" &&
              !backendUrl.includes("unifize.us") ? null : (
                <Text key={item} value={item} my={0}>
                  {stitchTypes[item]}
                </Text>
              )
            )}
          </Select>
        </VStack>
      </GridItem>

      <GridItem>
        {/* $FlowFixMe */}
        <StitchData
          stitchType={stitchType}
          // $FlowFixMe
          value={data[valueKey]}
          onUpdate={updateStitchData}
        />
      </GridItem>
    </Grid>
  );
}
